import React from "react";

export const Loader = ({ label = "Chargement…", className = "" }) => (
  <div data-testid="app-loader" className={`flex flex-col items-center justify-center gap-3 py-16 ${className}`}>
    <div className="relative h-10 w-10">
      <div className="absolute inset-0 rounded-full border-[3px] border-[#FF6A00]/20" />
      <div className="absolute inset-0 animate-spin rounded-full border-[3px] border-transparent border-t-[#FF6A00] border-r-[#FFD500]" />
    </div>
    {label && <p className="text-sm text-zinc-500">{label}</p>}
  </div>
);

export default Loader;
